import React, { useEffect, useState } from "react";
import "../App.css";
import { Navbar, Nav, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const NavigationBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goToSection = (id) => {
    navigate("/");

    // wait for homepage render then scroll
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`custom-navbar ${scrolled ? "navbar-scrolled" : ""}`}
    >
      <Container>
        <Navbar.Toggle className="bg-transparent ms-auto" />

        <Navbar.Collapse>
          <Nav className="ms-auto">

            {/* HOME */}
            <Nav.Link onClick={() => goToSection("hero")} className="text-white">
              HOME
            </Nav.Link>

            {/* SERVICES */}
            <Nav.Link
              onClick={() => goToSection("services")}
              className="text-white"
            >
              SERVICES
            </Nav.Link>

            {/* ABOUT */}
            <Nav.Link
              onClick={() => goToSection("about")}
              className="text-white"
            >
              ABOUT
            </Nav.Link>

            {/* TEAM */}
            <Nav.Link
              onClick={() => goToSection("team")}
              className="text-white"
            >
              TEAM
            </Nav.Link>

            {/* CONTACT */}
            <Nav.Link
              onClick={() => goToSection("contact")}
              className="text-white"
            >
              CONTACT
            </Nav.Link>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;